import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";
import { checkIfInIframe } from "../checkIfInIframe";
import ensureCsrfCookie, { refreshCsrfCookie } from "../ensureCsrfCookie";
import { getActiveCurrency } from "../getActiveCurrency";
import { getActiveMarket } from "../getActiveMarket";

// import { setCredentials, logOut } from "../../features/auth/authSlice";
const isInIframe = checkIfInIframe();

const BASE_URL = isInIframe
	? import.meta.env.VITE_IFRAME_API_URL
	: import.meta.env.VITE_API_URL;

// const TEST_BASE_URL = "https://apitest.profitboard.pl";
// const LIVE_BASE_URL = "https://api.profitboard.pl";
// const BASE_URL =
// 	process.env.NODE_ENV === "development"
// 		? import.meta.env.VITE_API_URL || "http://localhost:8080/"
// 		: window.location.host === "app.profitboard.pl"
// 		? LIVE_BASE_URL
// 		: TEST_BASE_URL;

const baseQuery = fetchBaseQuery({
	baseUrl: BASE_URL,
	mode: "cors",
	sameSite: "None",
	secure: true,
	credentials: "include",
	prepareHeaders: async (headers, builder) => {
		// Shared, awaited CSRF init - every request waits on the same
		// in-flight /sanctum/csrf-cookie call instead of racing ahead of it.
		try {
			await ensureCsrfCookie();
		} catch (err) {
			console.error("[apiSlice] Proceeding without a verified XSRF-TOKEN cookie:", err);
		}

		const xsrfToken = Cookies.get("XSRF-TOKEN");
		if (xsrfToken) {
			headers.set("X-XSRF-TOKEN", xsrfToken);
		}

		headers.set("X-Requested-With", "XMLHttpRequest");
		headers.set("Accept", "application/json");

		const activeMarket = getActiveMarket();
		headers.set("X-Market", activeMarket);
		const activeCurrency = getActiveCurrency();
		headers.set("X-Currency", activeCurrency);
		// All enpdoints that need to be send as formdata do not need Content Type as it is added with correct scope by mutation atrubite FormData
		if (
			builder.endpoint != "productsDataImport" &&
			builder.endpoint != "adsDataImport" &&
			builder.endpoint != "reportIssue"
		) {
			headers.set("Content-Type", "application/json");
		}
		return headers;
	},
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
	let result = await baseQuery(args, api, extraOptions);

	Cookies.set("last-api-call", Date.now());

	const responseStatus = result?.meta?.response?.status;
	const requestUrl = typeof args === "string" ? args : args?.url;

	if (responseStatus === 419) {
		// CSRF token mismatch/expired - make it visible instead of the request just hanging/failing silently.
		console.error(
			`[apiSlice] CSRF token mismatch (419) on "${requestUrl}" - refreshing CSRF cookie for the next request.`,
			result.error,
		);
		refreshCsrfCookie();
	}

	// Auto Logout test
	if (args != "/api/user" && responseStatus === 401) {
		console.error(`[apiSlice] Unauthorized (401) on "${requestUrl}", reloading page.`);
		location.reload();
	} else {
		return result;
	}
};

const apiSlice = createApi({
	baseQuery: baseQueryWithReauth,
	tagTypes: [
		"Users",
		"CompanySettings",
		"Banners",
		"ActiveBanners",
		"CompanySettings",
		"DashboardProducts",
		"DashboardOffers",
		"DashboardTiles",
		"Expenses",
		"OrdersProfitability",
	],
	endpoints: () => ({}),
});

export default apiSlice;
